// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import './components/element'
import './mixin'
import './api'
import './filter'
import './directives'
import './assets/style/index.scss'
import { i18n } from './i18n'
import './utils'
import App from './App'
import htmlToPdf from './utils/htmlToPdf'
import { ensureRefreshManagerInitialized } from './utils/refresh-manager'
import { ensurePollingTasksInitialized } from './utils/polling/global-polling'
import {
  ensureLoggerReady,
  ensureLoggerRefreshSubscription,
  isLoggerEnabled,
  syncLoggerEnabledFromUrl,
} from './utils/logger-report'
import RadioButton from 'element-ui/packages/radio-button'

// element-ui的 cascader bug 用 multiCascader 组件替换
import multiCascader from 'multi-cascader-base-ele'

function main() {
  Vue.use(multiCascader)

  Vue.config.productionTip = false
  Vue.use(htmlToPdf)
  Vue.use(RadioButton)

  syncLoggerEnabledFromUrl()
  ensureRefreshManagerInitialized()
  ensurePollingTasksInitialized()

  try {
    if (isLoggerEnabled()) {
      ensureLoggerReady()
    }
  } catch (error) {
    console.error('[logger-report] init failed', error)
  }

  try {
    ensureLoggerRefreshSubscription()
  } catch (error) {
    console.error('[logger-refresh] init failed', error)
  }

  /* eslint-disable no-new */

  const vm = new Vue({
    el: '#app',
    i18n,
    router,
    store,
    template: '<App/>',
    components: { App },
  })

  window.vm = vm
}
if (process.env.ENABLE_MOCK === true) {
  import('../dev/mock').then(({ enableMocking }) => {
    enableMocking().then(() => {
      main()
    })
  })
} else {
  main()
}
